/*
 *
 *  actions
 *
 */

import {
  //LOAD_VIDEO_TEAM
  LOAD_ACCESS,
  LOAD_ACCESS_SUCCESS,
  LOAD_ACCESS_ERROR,
  LOAD_MENU_LIST,
  LOAD_MENU_LIST_SUCCESS,
  LOAD_MENU_LIST_ERROR,
  LOAD_USER_ROLE_LIST,
  LOAD_USER_ROLE_LIST_SUCCESS,
  LOAD_USER_ROLE_LIST_ERROR,
  LOAD_USER_PERMISSON_LIST,
  LOAD_USER_PERMISSON_LIST_SUCCESS,
  LOAD_USER_PERMISSON_LIST_ERROR,
  LOAD_DASHBOARD_TRANSACTIONS,
  LOAD_DASHBOARD_TRANSACTIONS_SUCCESS,
  LOAD_DASHBOARD_TRANSACTIONS_ERROR,
  LOAD_INFO_LIST,
  LOAD_INFO_LIST_SUCCESS,
  LOAD_INFO_LIST_ERROR,
  LOAD_USER_ACCESS,
  LOAD_USER_ACCESS_SUCCESS,
  LOAD_USER_ACCESS_ERROR,
  LOAD_USER_MENU,
  LOAD_USER_MENU_SUCCESS,
  LOAD_USER_MENU_ERROR
} from "./constants";

// load parties
export function loadAccessList(accessList) {
  return {
    type: LOAD_ACCESS,
    accessList,
  };
}

export function loadAccessListSuccess(access_list, success) {
  return {
    type: LOAD_ACCESS_SUCCESS,
    access_list,
    success,
  };
}

export function loadAccessListError(error) {
  return {
    type: LOAD_ACCESS_ERROR,
    error,
  };
}

// load parties
export function loadMenuList(menuList) {
  return {
    type: LOAD_MENU_LIST,
    menuList,
  };
}

export function loadMenuListSuccess(menu_list, success) {
  return {
    type: LOAD_MENU_LIST_SUCCESS,
    menu_list,
    success,
  };
}

export function loadMenuListError(error) {
  return {
    type: LOAD_MENU_LIST_ERROR,
    error,
  };
}
// load parties
export function loadDashboardTransactions(menuList) {
  return {
    type: LOAD_DASHBOARD_TRANSACTIONS,
    menuList,
  };
}

export function loadDashboardTransactionsSuccess(
  dashboard_transactions,
  success
) {
  return {
    type: LOAD_DASHBOARD_TRANSACTIONS_SUCCESS,
    dashboard_transactions,
    success,
  };
}

export function loadDashboardTransactionsError(error) {
  return {
    type: LOAD_DASHBOARD_TRANSACTIONS_ERROR,
    error,
  };
}

// load total balance
export function loadUserRoleList(userRoleList) {
  return {
    type: LOAD_USER_ROLE_LIST,
    userRoleList,
  };
}

export function loadUserRoleListSuccess(user_role_list, success) {
  return {
    type: LOAD_USER_ROLE_LIST_SUCCESS,
    user_role_list,
    success,
  };
}

export function loadUserRoleListError(error) {
  return {
    type: LOAD_USER_ROLE_LIST_ERROR,
    error,
  };
}

// load user permission
export function loadUserPermissionList(userRoleList) {
  return {
    type: LOAD_USER_PERMISSON_LIST,
    userRoleList,
  };
}

export function loadUserPermissionListSuccess(user_permission_list, success) {
  return {
    type: LOAD_USER_PERMISSON_LIST_SUCCESS,
    user_permission_list,
    success,
  };
}

export function loadUserPermissionListError(error) {
  return {
    type: LOAD_USER_PERMISSON_LIST_ERROR,
    error,
  };
}


// load user permission
export function loadInfoList(info_List) {
  return {
    type: LOAD_INFO_LIST,
    info_List,
  };
}

export function loadInfoListSuccess(info_List, success) {
  return {
    type: LOAD_INFO_LIST_SUCCESS,
    info_List,
    success,
  };
}

export function loadInfoListError(error) {
  return {
    type: LOAD_INFO_LIST_ERROR,
    error,
  };
}

//LOAD USER ACCESS
export function loadUserAccessList(userAccess_list) {
  return {
    type: LOAD_USER_ACCESS,
    userAccess_list,
  };
}

export function loadUserAccessListSuccess(userAccess_list, success) {
  return {
    type: LOAD_USER_ACCESS_SUCCESS,
    userAccess_list,
    success,
  };
}

export function loadUserAccessListError(error) {
  return {
    type: LOAD_USER_ACCESS_ERROR,
    error,
  };
}

//LOAD MENU ACCESS
export function loadUserMenuAccessList(user_menu_list) {
  return {
    type: LOAD_USER_MENU,
    user_menu_list,
  };
}

export function loadUserMenuAccessListSuccess(user_menu_list, success) {
  return {
    type: LOAD_USER_MENU_SUCCESS,
    user_menu_list,
    success,
  };
}

export function loadUserMenuAccessListError(error) {
  return {
    type: LOAD_USER_MENU_ERROR,
    error,
  };
}


const actions = {
  loadAccessList,
  loadAccessListSuccess,
  loadAccessListError,

  loadMenuList,
  loadMenuListSuccess,
  loadMenuListError,
  
  loadUserPermissionList,
  loadUserPermissionListSuccess,
  loadUserPermissionListError,

  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,

  loadUserRoleList,
  loadUserRoleListSuccess,
  loadUserRoleListError,

  loadInfoList,
  loadInfoListSuccess,
  loadInfoListError,

  loadUserAccessList,
  loadUserAccessListSuccess,
  loadUserAccessListError,

  loadUserMenuAccessList,
  loadUserMenuAccessListSuccess,
  loadUserMenuAccessListError
};

export default actions;
